import React, { FC } from "react";

import { FavouritesSettingsMap } from "./FavouritesSettingsMap";
import { MapReportingProvider } from "../../../../map/MapReportingProvider";
import { FavouriteProvider } from "../../../../map/providers/FavouriteProvider";

import { IFavouritesSettingsMapProps } from "./FavouritesSettingsMap.types";
export const FavouritesSettingsMapProvider: FC<IFavouritesSettingsMapProps> = (props) => {
  return (
    <MapReportingProvider useOLAPService={false}>
      <FavouriteProvider applySavedFavouriteByDefault>
        <FavouritesSettingsMap {...props} />
      </FavouriteProvider>
    </MapReportingProvider>
  );
};
